import { useEffect } from "react";
import Header from "components/Common/Header/Header";
import HealthCenterGoalsBody from "components/ClinicalManagement/HealthCenters/Details/HealthCenterGoals/HealthCenterGoalsBody";

const HealthCenterGoals = () => {
  useEffect(() => {
    document.title = "Goals";
  }, []);

  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="clinicalmanagement" />
      <HealthCenterGoalsBody />
    </main>
  );
};

export default HealthCenterGoals;
